import Title from "./Title";
import { ColumnDef } from "@tanstack/react-table";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../../Services/apiService";
import Loading from "../General/Loading";
import PopupGlobel from "../../PopModal/PopupGlobel";
import AdvancedDataTable from "../General/Table";
type DataDto = {
  catId: number;
  name: string;
  desc: string;
};
const columns: ColumnDef<DataDto>[] = [
  {
    accessorKey: "portName",
    header: "الاسم",
  },
  {
    accessorKey: "shopId",
    header: "المعرف",
    enableHiding: true,
  },
    {
    accessorKey: "portCode",
    header: "عقد المتجر",
  } 
];
const ListShops = () => {
  const [loading, setLoading] = useState(false);
  const [errheader, seterrheader] = useState("");
  const [data, setData] = useState<any[]>([]);
  const [isSuccess, setIssuccess] = useState(false);
  const [isShowPopDelete, setisShowPopDelete] = useState(false);
  const [id, setID] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const navigate = useNavigate();
  useEffect(() => { 
    fetchData(); 
  }, []);
  const fetchData = async (): Promise<void> => {
    try {
      setLoading(true);
      const result = await apiService.fetchGetData("api/GetShops", {});
      setData(result.data);
      console.log(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setData([]);
      setLoading(false); // Handle error case
    }
  };
  const openEditPage = (id: any) => {
    navigate("/admin/mngShops?no=" + id);
  };
      const deleteData = async () => {
      try {  setLoading(true);
        const result = await apiService.fetchGetData("api/RemoveShop", {
          no: id,
        });
          if (result.isOk) {
          setSuccess("✅" + result.errAr);fetchData();
        } else setError("❌" + result.errAr);
        setisShowPopDelete(false);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };
 const openModalDelete = (id: any) => {
    setID(id);
    setisShowPopDelete(true);
  }; 
  return (
    <>
      {loading && <Loading />}
      {isShowPopDelete && (
        <PopupGlobel
          approveAction={() => deleteData()}
          cancelAction={() => {
            setisShowPopDelete(false);
          }}
          btnApproveTitle="حذف"
          btnCancelTitle="تراجع"
          title="تاكيد الحذف"
          popupType={2}
        >
          <p>هل انت متاكد من حذف البيانات؟ </p>
        </PopupGlobel>
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">
          <Title
            pageName="قائمة المتاجر"
            pageDesc=""
            isSearch={false}
            isAdd={true}
            addEvent={()=>navigate("/admin/mngShops")}
            AddText="إضافة متجر "
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-12 flex flex-col gap-8">
              {/* Profile Settings */}
              <section
                className="bg-surface-container-lowest rounded-2xl p-8 shadow-sm"
                id="profile"
              > 
                 {error && (
                  <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                    {success}
                  </div>
                )}
                <div className="flex items-center gap-4 mb-8 pb-4 border-b border-surface-container-highest">
                  <span className="material-symbols-outlined text-[28px] text-primary">
                    person
                  </span>
                  <h2 className="font-headline-md text-headline-md text-on-surface">
                    قائمة المتاجر
                  </h2>
                </div> 
                  <AdvancedDataTable
                    data={data}
                    columns={columns}
                    title="" 
                    isShowExportExcel={true}
                    idName="shopId"
                      Buttons={[
                    {
                      btnTitle: "تعديل",
                      btnActionType: 1,
                      btnAction: (id) => openEditPage(id),
                    },
                    {
                      btnTitle: "حذف",
                      btnActionType: 2,
                      btnAction: (id) => openModalDelete(id),
                    },
                  ]}
                  /> 
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ListShops;
